import { UserProfileDto, UserRole } from "@green0meter/api-client";

export const roleGuard = (
  user: UserProfileDto | null,
  allowedRoles: UserRole[],
): boolean => {
  return !!user && [UserRole.Admin, ...allowedRoles].includes(user.role);
};
